export default __webpack_public_path__ + "static/media/login_bg_lgeCWC.c3fe45c2.jpg";